module.exports = __webpack_public_path__ + "img/diaspora_humanitarianism_english.b8c64294.jpg";